import styled from 'foundations-theming/utils';
export const ColorIndicator = styled.div.withConfig({
  displayName: "ColorIndicator",
  componentId: "sc-1kttam7-0"
})(["position:absolute;top:0;bottom:0;left:0;width:4px;background-color:", ";"], ({
  forwarded,
  theme
}) => forwarded ? theme.color['fill-caution-default'] : theme.color['icon-core-subtle']);